﻿export class WorkTrayViewNotFound {
    constructor(public viewId: string) { }
}